import React, { useContext } from "react";
import "../Css/about.css";
import { Avatar, Box, Grid } from "@mui/material";
import { ThemeContext } from "../../context";

import pichere from "../../img/avatar_1.jpeg";
import piccs from "../../img/cs_logo.png";
import picpgsql from "../../img/postgresql-logo.png";
import picrjs from "../../img/reactjs_logo.gif";
import picaspdotnet from "../../img/asp.net_logo.png";
// import workspaceImage from "../../img/workspace.jpg";

import Footer from "../Footer";

import { motion } from "framer-motion";
import Edu from "./Edu";
import Exp from "./Exp";

import StarAbouts from "./StarAbouts";
// import LightModeConfetti from "./LightModeConfetti";
// import LightModeBubbles from "./LightModeBubbles";
import LightGradientBackground from "./LightGradientBackground";

const About = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  const animations = {
    initial: { opacity: 0, x: -100 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: -100 },
  };

  // const animationr = {
  //   initial: { opacity: 0, x: 100 },
  //   animate: { opacity: 1, x: 0 },
  //   exit: { opacity: 0, x: -100 },
  // };

  const skillshere = [
    {
      id: 1,
      image: piccs,
    },
    {
      id: 2,
      image: picaspdotnet,
    },
    {
      id: 3,
      image: picpgsql,
    },
    {
      id: 4,
      image: picrjs,
    },
  ];
  return (
    <div>
      {darkMode ? <StarAbouts /> : <LightGradientBackground />}
      <div className="my-component">
        <Grid
          container
          height={{ xs: "100%", lg: "100%" }}
          flexDirection="column"
          paddingTop={{ xs: "80px", lg: "100px", xl: "103px" }}
          paddingLeft={{ xs: "24px", lg: "134px" }}
          paddingRight={{ xs: "24px", lg: "135px" }}
          className="about"
          paddingBottom={{ xs: "20px", lg: "0" }}
        >
          <span
            className="ab-title"
            style={{
              borderLeft: darkMode ? "1px solid #a79149" : "2px solid #a5a5a5",
              borderBottom: darkMode
                ? "1px solid #a79149"
                : "2px solid #a5a5a5",
              boxShadow: darkMode
                ? "-5px 6px 10px #a79149"
                : "-8px 8px 10px rgba(0, 0, 0, 0.2)",
              cursor: "default",
            }}
          >
            About me
          </span>
          <Box display="flex" flexDirection={{ xs: "column", md: "row" }}>
            <Box
              width={{ xs: "100%", lg: "50%" }}
              display="flex"
              position="relative"
            >
              <Avatar
                sx={{
                  height: { xs: "200px", sm: "250px", lg: "300px" },
                  width: { xs: "200px", sm: "250px", lg: "300px" },
                  boxShadow: {
                    xs: "0",
                    md: darkMode ? "0 0 20px #d4af37" : "0 0 20px 2px #818589",
                  },
                  marginLeft: { xs: "auto", lg: "0" },
                  marginRight: { xs: "auto", lg: "0" },
                }}
                src={pichere}
              />
            </Box>
            <Box
              width={{ xs: "100%", lg: "50%" }}
              display="flex"
              flexDirection="column"
            >
              <Box
                height={{ xs: "100%", lg: "70%" }}
                className="ab-mainright"
                marginTop={{ xs: "18px", lg: "0px" }}
                sx={{
                  borderRadius: "12px",
                  background: darkMode ? "#222" : "#f7f6ef",
                  boxShadow: {
                    xs: "0",
                    md: darkMode ? "0 0 10px #d4af37" : "0 0 20px 2px #818589",
                  },
                  padding: "8px",
                  textAlign: "justify",
                  cursor: "default",
                }}
              >
                Hey there! I'm Deepangshi, Software Engineer. I'm currently
                working as a Software Developer | .Net Developer and learning to
                expand my skills in the field of tech.
                <br />
                <br />
                <br />
                My journey in software development began with a simple curiosity
                about how websites and applications are built. This curiosity
                quickly turned into a passion, leading me to dive deep into the
                world of coding.
              </Box>
              <Box
                // width={{ xs: "100%", lg: "50%" }}
                height={{ xs: "100%", lg: "70%" }}
                className={
                  darkMode
                    ? "ab-mainright collab-link"
                    : "ab-mainright collab-light-link"
                }
                marginTop={{ xs: "18px", lg: "15px" }}
                sx={{
                  borderRadius: "12px",
                  background: darkMode ? "#222" : "#f7f6ef",
                  // boxShadow: {
                  //   xs: "0",
                  //   md: darkMode ? "0 0 10px #d4af37" : "0 0 20px 2px #818589",
                  // },
                  padding: "8px",
                  textAlign: "justify",
                  cursor: "default",
                }}
              >
                <a
                  href="https://github.com/Deepangshi"
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontWeight: "bold",
                    textDecoration: "none",
                    background:
                      "linear-gradient(135deg, #4285f4, #34a853, #fbbc05, #ea4335)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    // color: darkMode ? "#d4af37" : "#818589",
                  }}
                >
                  always ready to collaborate.
                </a>
              </Box>
            </Box>
          </Box>

          <Box
            display="flex"
            marginTop="40px"
            marginBottom="30px"
            sx={{ cursor: "default" }}
          >
            <Box
              fontSize={{ xs: "24px", lg: "25px" }}
              fontWeight={{ xs: "200", lg: "400" }}
              className="ab-skills"
            >
              Skills
            </Box>
            <motion.div
              variants={animations}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 1.5 }}
            >
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  // alignItems: "center",
                  // alignContent: "center",
                  // justifyContent: "center",
                  gap: "1rem",
                  borderRadius: "12px",
                  background: darkMode ? "#222" : "#f7f6ef",
                  boxShadow: {
                    xs: "0",
                    md: darkMode ? "0 0 10px #d4af37" : "0 0 20px 2px #818589",
                  },
                  padding: "2px",
                }}
              >
                {skillshere.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: { xs: "35px", md: "50px", lg: "50px" },
                      height: { xs: "35px", md: "50px", lg: "50px" },
                    }}
                  >
                    <img
                      src={item.image}
                      alt=""
                      style={{
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </motion.div>
          </Box>

          <Edu />
          <Exp />

          {/* <Box
            sx={{
              backgroundImage: `url(${workspaceImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundAttachment: "fixed",
              height: { xs: "200px", md: "300px" },
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: { xs: "20px", md: "30px" },
              marginBotom: { xs: "20px", md: "30px" },
            }}
          ></Box> */}

          <Footer />
        </Grid>
      </div>
    </div>
  );
};

export default About;
